import { AnyAction } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { Action, Audit } from "../constants/interfaces";
import api from "../utils/api";

interface State {
  audits: Audit[];
  auditStatusMapper: {
    [Key: string]: string;
  };
  error: Error | null;
  loading: boolean;
}

export function getInitialState(): State {
  return {
    audits: [],
    auditStatusMapper: {
      Audited: "In progress",
      "Peer Review Audit Tool Required": "In progress",
      "Peer Review Audit Tool Completed": "In progress",
      "Assessment Required": "In progress",
      "Completion Assessment Required": "In progress",
      "Completed Compliant": "Completed Compliant",
      "Completed Non Compliant": "Completed Compliant",
      "Decision Required Audit Completion": "In progress",
      "Peer Review Memo Required": "In progress",
      "Peer Review Memo Completed": "In progress",
      "Review Completed": "In progress",
      "CAMs In Progress": "In progress",
      "Awaiting Response": "In progress"
    },
    loading: false,
    error: null
  };
}

export const auditTypes = {
  GET_AUDITS_REQUEST: "GET_AUDITS_REQUEST",
  GET_AUDITS_RESPONSE: "GET_AUDITS_RESPONSE"
};

export const auditActions: any = {
  getAudits: () => async (dispatch: ThunkDispatch<{}, {}, AnyAction>) => {
    dispatch({ type: auditTypes.GET_AUDITS_REQUEST });
    try {
      const { data: audits } = await api.get("/audits/getAuditHistory");
      dispatch({
        type: auditTypes.GET_AUDITS_RESPONSE,
        payload: audits,
        error: false
      });
    } catch (e) {
      dispatch({
        type: auditTypes.GET_AUDITS_RESPONSE,
        payload: e,
        error: true
      });
      return e;
    }
  }
};

export default function audit(state = getInitialState(), action: Action) {
  const { type, payload, error } = action;
  switch (type) {
    case auditTypes.GET_AUDITS_REQUEST: {
      return { ...state, loading: true, error: null };
    }
    case auditTypes.GET_AUDITS_RESPONSE: {
      if (error) {
        return {
          ...state,
          loading: false,
          error: payload,
          audits: state.audits
        };
      }
      return { ...state, loading: false, error: null, audits: payload };
    }
  }
  return state;
}
